import { useEffect, useState } from "react";
import Logo from "../../assets/Images/logo.svg";
import { HomeString } from "../../utils/string";
import { getAllMachinesCategoryList } from "../../services/machineService";
import { useLocation, useNavigate } from "react-router-dom";
import { loginRequest } from "../../config/msalConfig";
import { useMsal } from "@azure/msal-react";
import { jwtDecode } from "jwt-decode";
import { vizybilityConfig, ApplicationId } from "../../api/url";
import { postGetVizyBilityToken } from "../../services/getVizyBilityToken";
import { getGenericUserKey, getThirdPartyAzureService } from "../../services/getThirdPartyAzureService";
import { getAzureUser } from "../../services/updateAzureUser";
import { cleanObjectKeys } from "../../utils/helper";
import { useAuthModal } from "../../context/authModalContext";
const Footer = ({ List, isLoader }) => {
  let navigate = useNavigate();
  const location = useLocation();
  const { instance } = useMsal();
  const { openModal } = useAuthModal();
  const Logout = localStorage.getItem("getAzureUserData") || localStorage.getItem("azuretoken");
  const [machinesTypeList, setMachinesTypeList] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    GetMachinesTypeList();
  }, []);

  const GetMachinesTypeList = (val) => {
    setCategoryLoading(true);
    getAllMachinesCategoryList()
      .then((res) => {
        setCategoryLoading(false);
        setMachinesTypeList(res?.data.find((item) => item.AssetTypeId === 2).CategoryDetails);
      })
      .catch((err) => {
        setCategoryLoading(false);
        console.log(err);
      });
  };

  const handleLogin = async () => {
    setIsLoading(true);
    try {
      const idToken = await instance.loginPopup(loginRequest);
      handleRedirectCallback(idToken.accessToken);
      localStorage.setItem("vizy-azure-token", idToken.accessToken);
    } catch (error) {
      console.error("Login error:", error);
      setIsLoading(false);
    }
  };

  const handleRedirectCallback = async (response) => {
    try {
      const decodedToken = jwtDecode(response);

      if (!decodedToken?.extension_UserStatus) {
        await handleDefaultLogin(decodedToken, response);
        return;
      }

      switch (decodedToken.extension_UserStatus) {
        case undefined:
        case "Pending":
          await handlePendingStatus();
          break;

        case "Approved":
          await handleApprovedStatus(decodedToken);
          break;

        default:
          await handleDefaultStatus();
          break;
      }
    } catch (error) {
      console.error("Error handling redirect callback:", error);
      setIsLoading(false);
    }
  };

  const handleOpenWarning = () => {
    localStorage.setItem("OpenWarning", true);
  };

  const handlePendingStatus = async () => {
    await instance.logoutPopup({ postLogoutRedirectUri: window.location.origin });
    handleOpenWarning();
    localStorage.removeItem("vizy-bility-token");
    localStorage.removeItem("client_info");
    setIsLoading(false);
  };

  const handleApprovedStatus = async (decodedToken) => {
    const payload = new URLSearchParams({
      grant_type: vizybilityConfig.grant_type,
      username: decodedToken.extension_GenericWebUsername,
      password: decodedToken.extension_GenericWebUserPassword,
      client_id: vizybilityConfig.STS_CLIENT_ID,
      client_secret: vizybilityConfig.STS_CLIENT_SECRET,
      scope: vizybilityConfig.STS_SCOPE,
      ApplicationId,
    });

    setIsLoading(true);
    try {
      const res = await postGetVizyBilityToken({
        url: vizybilityConfig.STS_SIGNIN_URL,
        payload,
      });

      if (res?.data?.access_token) {
        localStorage.setItem("vizy-bility-token", res.data.access_token);
        localStorage.setItem("client_info", JSON.stringify(decodedToken));

        const header = { authorization: `Bearer ${res.data.access_token}` };
        const ThirdPartyAzureToken = await getThirdPartyAzureService(header);
        const headerUser = {
          Authorization: `Bearer ${ThirdPartyAzureToken?.data?.access_token}`,
        };
        const getGenericUser = await getGenericUserKey(header);
        const applicationId = JSON.parse(getGenericUser?.data?.SettingValue)?.AzureB2CApplicationID;
        const query = `${decodedToken.sub}?$select=id,givenName,surname,identities,extension_${applicationId}_CreatedDatetime,extension_${applicationId}_UserStatus,extension_${applicationId}_ContactId,extension_${applicationId}_CompanyName,extension_${applicationId}_CompanyId,extension_${applicationId}_EmailAddresses,extension_${applicationId}_Phone,extension_${applicationId}_IsActive,extension_${applicationId}_DeactivationDatetime,extension_${applicationId}_ContactUserName`;
        const AzureUserData = await getAzureUser(query, headerUser);
        localStorage.setItem("getAzureUserData", JSON.stringify(cleanObjectKeys(AzureUserData?.data)));
        if (location.pathname === "/admin/add-list") {
          // Redirect to another path if the condition is met
          navigate("/admin/add-list");
          window.location.reload();
        } else {
          // If not, stay on the current page or navigate to the admin page
          // navigate("/admin/dashboard");
          window.location.reload();
        }
      }
      setIsLoading(false);
    } catch (error) {
      await handlePendingStatus();
    }
  };

  const handleDefaultLogin = async (decodedToken, response) => {
    const payload = new URLSearchParams({
      grant_type: vizybilityConfig.grant_type,
      username: vizybilityConfig.GenericWebUsername,
      password: vizybilityConfig.GenericWebUserPassword,
      client_id: vizybilityConfig.STS_CLIENT_ID,
      client_secret: vizybilityConfig.STS_CLIENT_SECRET,
      scope: vizybilityConfig.STS_SCOPE,
      ApplicationId,
    });

    setIsLoading(true);
    try {
      const res = await postGetVizyBilityToken({
        url: vizybilityConfig.STS_SIGNIN_URL,
        payload,
      });

      if (res?.data?.access_token) {
        localStorage.setItem("vizy-bility-token", res.data.access_token);
        localStorage.setItem("client_info", JSON.stringify(decodedToken));
        localStorage.setItem("azuretoken", response);
        localStorage.setItem("vizy-azure-token", response);
        navigate("/admin");
      }
      setIsLoading(false);
    } catch (error) {
      await handlePendingStatus();
    }
  };

  const handleDefaultStatus = async () => {
    await handlePendingStatus();
  };
  return (
    <>
      {isLoading ? (
        <div className="fixed top-0 w-[100%] h-[100dvh] bg-[#00000066] flex justify-center items-center z-50">
          <span class="loader"></span>
        </div>
      ) : null}
      <div className="bg-[#161412]">
        <div className="custom-container py-[28px]">
          {/* Big Screen */}
          <div className="hidden md:grid grid-cols-5 max-[1050px]:grid-cols-3 gap-6 ">
            <div>
              <img src={Logo} alt="" />
            </div>
            <div>
              <div className="text-white text-[14px] font-medium">{HomeString.ABOUT}</div>

              {!Logout && (
                <div
                  className="text-white text-[14px] font-medium cursor-pointer"
                  onClick={() => {
                    openModal("login");
                  }}
                >
                  {HomeString.LOGIN}
                </div>
              )}
              <div className="text-white text-[14px] font-medium">{HomeString.PRIVACY_POLICY}</div>
              <div className="text-white text-[14px] font-medium">{HomeString.TERMS_OF_USE}</div>
              <div className="text-white text-[14px] font-medium">{HomeString.CONTACT_US}</div>
            </div>
            {Array.from({ length: 3 }).map((_, colIndex) => (
              <div key={colIndex}>
                {machinesTypeList
                  .filter((_, index) => index % 3 === colIndex) // Distribute items into 3 columns
                  .map((machine, index) => (
                    <div
                      key={index}
                      className="text-white text-[14px] font-medium cursor-pointer"
                      onClick={() => {
                        window.scrollTo({
                          top: 0,
                          behavior: "smooth",
                        });
                        navigate(`/search`, {
                          state: {
                            keywords: null,
                            selectMake: "",
                            selectCategory: JSON.stringify([machine]),
                          },
                        });
                      }}
                    >
                      {machine.CategoryName}
                    </div>
                  ))}
              </div>
            ))}
          </div>

          {/* Sm screen */}
          <div className="grid md:hidden grid-cols-1 gap-6">
            <div>
              <img src={Logo} alt="" />
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <div className="text-white text-[14px] font-medium">{HomeString.ABOUT}</div>

                {!Logout && (
                  <div
                    className="text-white text-[14px] font-medium cursor-pointer"
                    onClick={() => {
                      openModal("login");
                    }}
                  >
                    {HomeString.LOGIN}
                  </div>
                )}
                <div className="text-white text-[14px] font-medium">{HomeString.PRIVACY_POLICY}</div>
                <div className="text-white text-[14px] font-medium">{HomeString.TERMS_OF_USE}</div>
                <div className="text-white text-[14px] font-medium">{HomeString.CONTACT_US}</div>
              </div>

              <div>
                {machinesTypeList // Distribute items into 3 columns
                  .map((machine, index) => (
                    <div
                      key={index}
                      className="text-white text-[14px] font-medium cursor-pointer"
                      onClick={() => {
                        window.scrollTo({
                          top: 0,
                          behavior: "smooth",
                        });
                        navigate(`/search`, {
                          state: {
                            keywords: null,
                            selectMake: "",
                            selectCategory: JSON.stringify([machine]),
                          },
                        });
                      }}
                    >
                      {machine.CategoryName}
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
